<template>
  <div>
    纠纷
  </div>
</template>

<script>
export default {

};
</script>

<style>

</style>
